/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { ButtonGroup, Card, Col, Container, Row } from "react-bootstrap"
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "../../components"
import { GetCourtsDetail } from "../../utilities/api/courts";
import { CourtDetailsType } from "../../utilities/types";
import { ArchiveCourt } from "./ArchiveCourt";
import { ToastContainer, toast } from "react-toastify";

const CourtInfo = () => {

    const [archive, setArchive] = useState(false);
    const location = useLocation()
    const navigate = useNavigate()
    const [courtDetails, setCourtDetails] = useState<CourtDetailsType>()

    const GetInfo = async () => {
        const result = await GetCourtsDetail(location.state)
        if (result.statusCode === 200) {
            setCourtDetails(result.data)
        } else {
            toast.error(result.response.data.message);
        }
    }

    useEffect(() => {
        GetInfo()
    }, [])

    const handleEdit = () => {
        navigate("/update-court", { state: location.state })
    }

    return (
        <Container fluid className="g-0">
            <Card>
                <Card.Body>
                    <div className="page-title align-items-center d-flex justify-content-between">
                        <Card.Title className="mb-0">Court Details </Card.Title>
                        <ButtonGroup>
                            <Button onClick={() => setArchive(true)} type="button" bname="Delete Court" name="delete-court" id="delete-court" className="btn btn-light rounded-1 me-3"></Button>
                            <Button onClick={handleEdit} type="button" bname="Edit Court" name="edit-court" id="edit-court" className="btn btn-primary rounded-1"></Button>
                        </ButtonGroup>
                    </div>
                    <div className="align-items-center d-flex justify-content-between">
                        <h4 className="align-items-center card-title2 d-flex fs-2 fw-semibold mb-0">{courtDetails?.name} <span className="badges ms-2 rounded-pill text-success badges-success">{courtDetails?.isActive ? "Active" : "Inactive"}</span></h4>
                    </div>
                    <hr />
                    <Row>

                        <Col lg={12}>
                            <div className="facility-details">
                                <Row className="text-start row-mb">
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">facility</span>
                                        <span className="user-info">{courtDetails?.facility.name}</span>
                                    </Col>
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">Sports</span>
                                        <span className="user-info">{courtDetails?.sport.name}</span>
                                    </Col>
                                </Row>
                                <Row className="text-start row-mb">
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">Max pre booking days</span>
                                        <span className="user-info">{courtDetails?.preBookingMaxDays} Days</span>
                                    </Col>
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">Max Reschedule days</span>
                                        <span className="user-info">{courtDetails?.rescheduleMaxDays} Days</span>
                                    </Col>
                                </Row>
                                <Row className="text-start row-mb" >
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">court timing </span>
                                        <span className="user-info">{courtDetails?.openTime.slice(0, 5)} to {courtDetails?.closeTime.slice(0, 5)}</span>
                                    </Col>
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">slot duration</span>
                                        <span className="user-info">{courtDetails?.slotDuration} Min</span>
                                    </Col>
                                </Row>
                                <Row className="text-start row-mb" >
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">Created by</span>
                                        <span className="user-info">{courtDetails?.createdByUser?.firstName} {courtDetails?.createdByUser?.lastName}</span>
                                    </Col>
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">Created at</span>
                                        <span className="user-info">{courtDetails?.createdAt}</span>
                                    </Col>
                                </Row>
                                <Row className="text-start row-mb" >
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">Updated by</span>
                                        <span className="user-info">{courtDetails?.updatedByUser?.firstName} {courtDetails?.updatedByUser?.lastName}</span>
                                    </Col>
                                    <Col>
                                        <span className="user-info-title text-info text-uppercase d-block mb-2">Updated at</span>
                                        <span className="user-info">{courtDetails?.updatedAt}</span>
                                    </Col>
                                </Row>
                                <Row className="text-start row-mb g-0 ">
                                    <span className="user-info-title text-info text-uppercase d-block mb-2">Court Rates</span>
                                    {courtDetails?.courtRates?.map((item: any, index: number) => {
                                        const nextItem = courtDetails.courtRates[index + 1];
                                        return (
                                          <React.Fragment key={index}>
                                            {/* Active Slot */}
                                            <div
                                              className="badge bg-light h-100 me-2 p-2 slot-box text-start"
                                              style={{ maxWidth: "180px" }}
                                            >
                                              <span className="d-block text-black mb-2">
                                                Time :{" "}
                                                <span className="text-primary">
                                                  {item.startTime} to {item.endTime}
                                                </span>
                                              </span>

                                              <span className="d-block text-black">
                                                Rate Per Slot :{" "}
                                                <span className="text-primary">
                                                  <span className="rupees-symbol">&#8377;</span>{" "}
                                                  {item.ratePerSlot}
                                                </span>
                                              </span>
                                            </div>

                                            {/* Gap Slot */}
                                            {nextItem && item.endTime < nextItem.startTime && (
                                              <div
                                                className="badge bg-light h-100 me-2 p-2 slot-box text-start"
                                                style={{
                                                  maxWidth: "180px",
                                                  border: "1px solid #B9362F",
                                                  // animation: "borderBlink 2s ease-in-out infinite",
                                                  opacity: 0.6,
                                                }}
                                              >
                                                <span className="d-block text-black mb-2">
                                                  Time :{" "}
                                                  <span className="text-primary">
                                                    {item.endTime} to {nextItem.startTime}
                                                  </span>
                                                </span>

                                                <span className="d-block text-primary">
                                                  <span className="text-dark">Status :</span>{" "}
                                                  <span className="small">
                                                    Inactive (No booking)
                                                  </span>
                                                </span>
                                              </div>
                                            )}
                                          </React.Fragment>
                                        );
                                    })}
                                    <span className="badge mt-2 ps-0 text-black text-start">Note : If you have not selected a specific time slot, the default rate for the slot will be <span className="text-primary"><span className="rupees-symbol">&#8377;</span>{courtDetails?.defaultRatePerSlot}</span>. </span>
                                </Row>
                                <Row className="text-start row-mb g-0 ">
                                    <span className="user-info-title text-info text-uppercase d-block mb-2">Court Taxes</span>
                                    {courtDetails?.courtTaxes?.map((item: any, index: number) => {
                                        return (
                                            <div key={index} className="badge bg-light h-100 me-2 p-2 slot-box text-start" style={{ maxWidth: '110px' }}>
                                                <span className="d-block text-black">{item.tax.name}: <span className="text-primary">{item.percentage} %</span></span>
                                            </div>
                                        )
                                    })}
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <ArchiveCourt setArchive={setArchive} archive={archive} id={location.state} />
            <ToastContainer />
        </Container>
    )
}

export { CourtInfo }
